module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vulpecula/vul_names-3c5854572e84009719a4abeebce1b47f.gif";